import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoginComponent } from './login/login.component';
import { LibModule } from '../lib/lib.module';
import { TranslateModule } from '@ngx-translate/core';
import { PasswordRecoveryComponent } from './password-recovery/password-recovery.component';
import { PasswordRecoveryPageComponent } from './password-recovery-page/password-recovery-page.component';
import { RouterModule } from '@angular/router';
import { PasswordRecoveryConfirmationComponent } from './password-recovery-confirmation/password-recovery-confirmation.component';
import { PasswordChangeComponent } from './password-change/password-change.component';
import { RegistrationComponent } from './registration/registration.component';
import { PasswordComponent } from './password/password.component';
import { UserDetailsModule } from '../users/user-details/user-details.module';

@NgModule({
  declarations: [
    LoginComponent,
    PasswordRecoveryComponent,
    PasswordRecoveryPageComponent,
    PasswordRecoveryConfirmationComponent,
    PasswordChangeComponent,
    PasswordComponent,
    RegistrationComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    TranslateModule,
    LibModule,
    UserDetailsModule
  ],
  exports: [
    LoginComponent,
    PasswordRecoveryComponent,
    PasswordRecoveryPageComponent,
    PasswordRecoveryConfirmationComponent,
    PasswordChangeComponent,
    PasswordComponent,
    RegistrationComponent
  ]
})
export class LoginModule { }
